/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.academics.grading-comments'},
});

const GradingCommentsItem = () => (
  <RouteLinkItem
    route="midas/settings/academics/grading-comments"
    title={messages.title}
  />
);

export default GradingCommentsItem;
